export const GET_ALL_POSTS = "GET-ALL-POSTS";
export const GET_SINGLE_POSTS = "GET-SINGLE-POSTS";
export const GET_TRADE_POST_OPTIONS = "GET-TRADE-POST-OPTIONS";
export const CREATE_POSTS = "CREATE-POSTS";
